import { FC } from "react";
import { Modal } from "@monolith-forensics/monolith-ui";
import { CreateUserRoleForm } from "@/components/Forms";

interface CreateUserRoleModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit: () => void;
  onCancel: () => void;
}

export const CreateUserRoleModal: FC<CreateUserRoleModalProps> = ({
  show,
  onClose,
  onSubmit,
  onCancel,
}) => {
  const handleSubmit = async () => {
    onSubmit?.();
    handleClose();
  };
  const handleClose = () => {
    onClose();
  };
  const handleCancel = () => {
    onCancel?.();
  };
  return (
    <Modal open={show} onClose={onClose} style={{ width: 550 }}>
      <Modal.Title style={{ marginBottom: 10 }}>Create User Role</Modal.Title>
      <CreateUserRoleForm onSubmit={handleSubmit} onCancel={handleCancel} />
    </Modal>
  );
};
